<template>
    <div class="ProductViewer h-100" :class="{
        'ProductViewer--is-touch': isTouch,
        'ProductViewer--single': isSingle
    }">
        <div class="row h-100 justify-content-center">
            <div class="col-auto ProductViewer__thumbnail-col">
                <ul class="list-unstyled ProductViewer__thumbnail-list">
                    <li v-for="(thumbnail, i) in thumbnails">
                        <button class="btn ProductViewer__thumbnail" :class="{ 'ProductViewer__thumbnail--active': i===current }" @click="set(i)">
                            <img :src="thumbnail.url" :alt="legend" class="mw-100">
                        </button>
                    </li>
                </ul>
            </div>
            <div class="col ProductViewer__slider-col">
                <div class="responsive-ratio" :class="{ [`responsive-ratio-${ratio}`]: ratio }">
                   <div :class="{ 'responsive-ratio-item':ratio }" v-loading="loading">
                       <carousel
                           :navigate-to="current"
                           :per-page="1"
                           ref="slider"
                           @pageChange="handleSlideChanged"
                       >
                           <slide v-for="(image, i) in images" :key="image.url" ref="item">
                               <div class="ProductViewer__slide">
                                   <img v-if="current===i || image.loaded" :src="image.url" :alt="legend" class="mw-100" @load="handleImageLoaded(i)">
                               </div>
                           </slide>
                       </carousel>
                   </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';


    export default {
        props: {
            images: Array,
            thumbnails: Array,
            legend: String,
            ratio:String
        },
        components: {
            Carousel,
            Slide
        },
        data() {
            return {
                current: 0,
                loading: false,
                isTouch: false
            }
        },
        computed: {
            isSingle() {
                return (this.images||[]).length === 1;
            }
        },
        methods: {
            handleSlideChanged(index) {
                this.loading = !this.images[index].loaded;
                this.current = index;
            },
            handleImageLoaded(index) {
                this.$set(this.images[index], 'loaded', true);
                this.loading = false;
            },
            set(index) {
                this.current = index;
            },
            handleIsTouchscreen() {
                this.isTouch = true;
            }
        },
        created() {
            document.addEventListener('touchstart', this.handleIsTouchscreen);
        }
    }
</script>